import React from 'react';
import { Provider } from 'react-redux';
import ReactDOM from 'react-dom';
import store from './store/store';
import { BrowserRouter } from 'react-router-dom';
import { Switch } from 'react-router';
import './styles/index.css';
import App from './App';
import { FIREBASE_PROJECT_ID } from './firebase-config';
import registerServiceWorker from './registerServiceWorker';
import {Helmet} from "react-helmet";

ReactDOM.render(
    <React.Fragment>
        <Helmet>
            <link rel="shortcut icon" href={ FIREBASE_PROJECT_ID === 'uxs-autumn' ? './logoUX.png' : './cy-x_logo.png' } />
        </Helmet>
        <Provider store={store()}>
            <BrowserRouter>
                <Switch>
                    <App />
                </Switch>
            </BrowserRouter>
        </Provider>
    </React.Fragment>
    , document.getElementById('root'));
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js